import { DocumentNode } from '@apollo/client';
import { fetchTemplateTypeAndLocalesQuery } from 'api/queries';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';
import { isDefined } from 'utils/tsHelpers';
import { MediumContent } from 'modules/graphql';
import { TemplateType } from '../common/types';

export type FetchCampaignByIdQueryRequest = {
  campaignId: number;
};

type FetchTemplateTypeAndLocalesByIdQueryResponse = {
  templateAndContent: {
    templateType: TemplateType;
    localeContents?: MediumContent[];
  };
};

export type UseTemplateTypeAndLocalesByIdResponse = {
  results: {
    templateAndContent: {
      templateType: TemplateType;
      localeContents?: MediumContent[];
    };
  };
};

export function useTemplateTypeAndLocalesById(
  options: Record<string, any>,
  query: DocumentNode = fetchTemplateTypeAndLocalesQuery, // eslint-disable-line
): UseTemplateTypeAndLocalesByIdResponse {
  const queryOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      ...options,
    }),
    [options],
  );
  const { data: fetchTemplateTypeByIdQueryData } = useGraphql(query, queryOptions);

  // protect against the undefined response while the query is running
  if (isDefined<FetchTemplateTypeAndLocalesByIdQueryResponse>(fetchTemplateTypeByIdQueryData)) {
    const results = fetchTemplateTypeByIdQueryData || {};

    return {
      results,
    };
  }

  return {
    results: {} as FetchTemplateTypeAndLocalesByIdQueryResponse,
  };
}
